import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import FirstParty from './components/firstParty'

class App extends Component {

  constructor(props) {
    super(props)
    this.state = {

    }

  }

  render() {
    let viewHtml ="";

    viewHtml = <Router>
      <div>
        <Routes>
          <Route path="/:key?" element={<FirstParty />} />
          {/* <Route component={FirstParty} exact path="/:key?" /> */}
        </Routes>
      
      </div>
    </Router>

    return (
      <div className="App">
        <header className="App-header">
        {viewHtml}
        </header>
      </div>
    );
  }
}

export default App;
